import { login, logout, getInfo } from '@/api/login'
import {getToken, removeToken, setTokenExpired} from '@/utils/auth'
import md5 from 'js-md5'
import { Message } from 'element-ui'
import config from '@/config'

const user = {
    state: {
        token: getToken(),
        id: '',
        name: '',
        nickName: '',
        avatar: '',
        roles: [],
        permissions: []
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_ID: (state, id) => {
            state.id = id
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_NICK_NAME: (state, name) => {
            state.nickName = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        }
    },

    actions: {
        // 登录
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim()
            const password = md5(userInfo.password)
            const code = userInfo.code
            const uuid = userInfo.uuid
            return new Promise((resolve, reject) => {
                login(username, password, code, uuid).then(res => {
                    // setToken(res.data.token)
                    setTokenExpired(res.data.token, 7)
                    commit('SET_TOKEN', res.data.token)
                    resolve()
                }).catch(error => {
                    // console.log(error)
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    const user = res.data.user
                    const avatar = (user.avatar === '' || user.avatar == null) ? require("@/assets/img/profile.jpeg") : baseUrl + user.avatar;
                    if (res.data.roles && res.data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                        commit('SET_ROLES', res.data.roles)
                        commit('SET_PERMISSIONS', res.data.permissions)
                    } else {
                        commit('SET_ROLES', ['ROLE_DEFAULT'])
                    }
                    commit('SET_ID', user.userId)
                    commit('SET_NAME', user.userName)
                    commit('SET_NICK_NAME', user.nickName)
                    commit('SET_AVATAR', avatar)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 退出系统
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    commit('SET_PERMISSIONS', [])
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ID', '')
                    commit('SET_NAME', '')
                    commit('SET_NICK_NAME', '')
                    commit('SET_AVATAR', '')
                    removeToken()
                    resolve()
                    Message.success('已退出登录')
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}

export default user
